import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "../helpers/analytics";

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // ConsentManager handles consent checking and script loading
    // This hook just tracks pageviews when gtag is available
    if (window.gtag) {
      pageview(location.pathname + location.search);
    }
  }, [location]);
}
